<template>
<div class="ew-topbar">
  <b-navbar toggleable="md" class="ew-topbar__inner">
    <b-navbar-brand class="ew-topbar__title">{{ name }}</b-navbar-brand>

    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav class="ml-auto ew-topbar__actions">
        <form
          class="ew-track"
          v-if="searchVisible"
          @submit.prevent="track(guide)"
        >
          <label class="sr-only" for="ew-track-input">Número de guía</label>
          <input
            id="ew-track-input"
            type="text"
            class="ew-track__input"
            placeholder="N° de guía"
            v-model="guide"
            required
          >
          <button class="ew-track__submit" type="submit" aria-label="Rastrear">
            <ph-icon name="magnifying-glass" />
          </button>
        </form>

        <a
          class="ew-topbar__link"
          href="#"
          @click.prevent="toggleSearch()"
        >
          <ph-icon name="map-pin" />
          <span>Rastrear</span>
        </a>

        <b-nav-item-dropdown right class="ew-topbar__user">
          <template slot="button-content">
            <span class="ew-topbar__user-name">{{ userDisplayName }}</span>
          </template>
          <b-dropdown-item to="/configuracion">Configuración</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item to="/preguntas-frecuentes">Guía de usuario</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="logout">Cerrar sesión</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>

  <b-modal
    ref="trackingModal"
    title="Resultado del envío"
    size="lg"
    ok-only
    ok-title="Cerrar"
    modal-class="ew-tracking-modal"
  >
    <div v-if="isLoadingTracking" class="ew-tracking-loading">Cargando...</div>
    <div v-else>
      <div class="alert alert-warning" v-if="trackingNotFound">
        El N° de guía {{ guide }} no ha sido localizado.
      </div>

      <template v-if="trackingResult && !trackingNotFound">
        <div v-if="trackingResult.type === 'dhl'">
            <div class="bg-light border px-3 py-3 mb-3">
            <div class="row">
              <div class="col">
                <div class="font-weight-bold">N° de guía: {{ trackingResult.guide }}</div>
                <div class="font-weight-bold text-primary">{{ eventsDescrip(lastEvent(trackingEventsByDate()), trackingEventsByDate()) }}</div>
              </div>

              <div class="col">
                <div class="font-weight-bold">
                  {{ formatDate(trackingResult.date) }}
                </div>
                <div>
                  <div class="font-weight-bold">Enviado desde:</div>
                  <div>{{trackingResult.shipper.city}}</div>

                  <div class="font-weight-bold">Enviado hacia:</div>
                  <div>{{trackingResult.consignee.city}}</div>
                </div>
              </div>

              <div class="col-auto font-weight-bold">
                {{ trackingResult.package }} Paquete
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table mb-3" v-for="(te, i) of trackingEventsByDate()" :key="i">
              <thead class="thead-light border">
                <th>{{ te[0].date }}</th>
                <th>Ubicación</th>
                <th>Hora</th>
                <th>Paquete</th>
              </thead>

              <tbody>
                <tr v-for="(e, i) of te" :key="i">
                  <td>{{ e.event.status }}</td>
                  <td>{{ e.event.location }}</td>
                  <td>{{ e.event.time }}</td>
                  <td class="text-right">{{ trackingResult.package }} Paquete</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-if="trackingResult.type === 'redpack'">
            <div class="bg-light border px-3 py-3 mb-3">
            <div class="row">
              <div class="col">
                <div class="font-weight-bold">N° de guía: {{ trackingResult.guide }}</div>
                <div class="font-weight-bold text-primary">ENTREGADO</div>
              </div>

              <div class="col">
                <div class="font-weight-bold">
                  {{ formatDate(trackingResult.date) }}
                </div>
                <div>
                  <div class="font-weight-bold">Enviado desde:</div>
                  <div>{{trackingResult.shipper.city}}</div>

                  <div class="font-weight-bold">Enviado hacia:</div>
                  <div>{{trackingResult.consignee.city}}</div>
                </div>
              </div>

              <div class="col-auto font-weight-bold">
                {{ trackingResult.package }} Paquete
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table mb-3" v-for="(te, i) of trackingEventsByDate()" :key="i">
              <thead class="thead-light border">
                <th>{{ te[0].date }}</th>
                <th>Ubicación</th>
                <th>Paquete</th>
              </thead>

              <tbody>
                <tr v-for="(e, i) of te" :key="i">
                  <td>{{ e.event.status }}</td>
                  <td>{{ e.event.location }}</td>
                  <td class="text-right">{{ trackingResult.package }} Paquete</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-if="trackingResult.type === 'fedex'">
            <div class="bg-light border px-3 py-3 mb-3">
            <div class="row">
              <div class="col">
                <div class="font-weight-bold">N° de guía: {{ trackingResult.guide }}</div>
                <div class="font-weight-bold text-primary">ENTREGADO</div>
              </div>

              <div class="col">
                <div class="font-weight-bold">
                  {{ formatDate(trackingResult.date) }}
                </div>
                <div>
                  <div class="font-weight-bold">Enviado desde:</div>
                  <div>{{trackingResult.shipper.city}}</div>

                  <div class="font-weight-bold">Enviado hacia:</div>
                  <div>{{trackingResult.consignee.city}}</div>
                </div>
              </div>

              <div class="col-auto font-weight-bold">
                {{ trackingResult.package }} Paquete
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table mb-3" v-for="(te, i) of trackingEventsByDate()" :key="i">
              <thead class="thead-light border">
                <th>{{ te[0].date }}</th>
                <th>Ubicación</th>
                <th>Paquete</th>
              </thead>

              <tbody>
                <tr v-for="(e, i) of te" :key="i">
                  <td>{{ e.event.status }}</td>
                  <td>{{ e.event.location }}</td>
                  <td class="text-right">{{ trackingResult.package }} Paquete</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </template>
    </div>
  </b-modal>
</div>
</template>

<script>
import commons from '../../commons';
import { mapGetters, mapActions, mapMutations } from 'vuex'
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/es';
import PhIcon from '../icons/PhIcon'

export default {
  name: 'NavBar',
  props: {
    name:String,
  },
  data () {
    return {
     location:null,/**ew-home, ew-dash */
      isLoging:false,
      path:null,
      searchVisible: false,
      guide: '',
      trackingResult: null,
      isLoadingTracking: false,
      trackingNotFound: false
    }
  },
  methods:{
    logout(){
      this.isLoging = false
      localStorage.clear()
      this.$router.push('/signin')
    },
    formatDate (date) {
      return moment(date).format('ddd D [de] MMMM [de] YYYY')
    },
    track (guide) {
      this.trackingNotFound = false
      if (guide.length > 6) {
        this.isLoadingTracking = true
        this.$refs.trackingModal.show()
        const url = `${commons.apiURL}/api/v1/tracking`
        axios
          .post(url, { guide_number: guide })
          .then(response => {
            console.log(response.data)
            if (response.data.status === 404) {
              this.trackingNotFound = true
            } else {
              this.trackingResult = response.data
            }
          })
          .catch(() => {})
          .finally(() => {
            this.isLoadingTracking = false
          })
      }
    },
    toggleSearch () {
      this.searchVisible = !this.searchVisible
    },
    trackingEventsByDate () {
      const events = {}
      this.trackingResult.shipment_event.map(e => {
        const date = e.date
        if (!events.hasOwnProperty(date)) {
          events[date] = []
        }
        events[date].push({
          date: this.formatDate(date),
          event: e
        })
      })
      console.log(events)
      return events
    },
    lastEvent(object){
      var last  = {};
      for (const key in object) {
        last = key;
      }
      return last
    },
    eventsDescrip(key, object){
      var listEvent = object[key].length -1;
      var list = object[key]
      return list[listEvent].event.status
    },
    ...mapActions(['getUser']),
    ...mapMutations(["setUser"])

  },
  created(){
    this.getUser()
  },
  computed:{
     ...mapGetters(['user']),
     // El estado inicial de Vuex es `user: {}`; si getUser() no llega a
     // responder (sesión vencida, red lenta) firstName/lastName quedan
     // undefined y se veía literal "undefined undefined" en la barra.
     userDisplayName () {
       if (this.user && this.user.firstName) {
         return `${this.user.firstName} ${this.user.lastName || ''}`.trim()
       }
       return 'Mi cuenta'
     }
  },
  components: {
    PhIcon
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/styles/app-tokens";

.ew-topbar {
  @include app-tokens;
}

.ew-topbar__inner {
  padding: 0 2rem;
  height: 4rem;
  background: var(--app-canvas);
  border-bottom: 1px solid var(--app-border);
}

.ew-topbar__title {
  margin: 0;
  font-family: var(--app-font);
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--app-navy);
}

.ew-topbar__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.ew-topbar__link {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  height: 2.5rem;
  padding: 0 0.75rem;
  border-radius: var(--app-radius-sm);
  color: var(--app-navy-secondary);
  font-family: var(--app-font);
  font-size: 0.85rem;
  font-weight: 600;

  svg { width: 1.05rem; height: 1.05rem; }

  &:hover {
    color: var(--app-navy);
    background: var(--app-surface-muted);
    text-decoration: none;
  }

  &:focus-visible {
    outline: 3px solid var(--app-accent);
    outline-offset: 3px;
  }
}

.ew-track {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-right: 0.5rem;
}

.ew-track__input {
  height: 2.5rem;
  padding: 0 0.85rem;
  border: 1px solid var(--app-border);
  border-radius: var(--app-radius-sm);
  font-family: var(--app-font);
  font-size: 0.85rem;
  color: var(--app-navy);
  min-width: 11rem;

  &:focus {
    outline: none;
    border-color: var(--app-accent);
  }
  &:focus-visible {
    outline: 3px solid var(--app-accent);
    outline-offset: 2px;
  }
}

.ew-track__submit {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  flex-shrink: 0;
  border: none;
  border-radius: var(--app-radius-sm);
  background: var(--app-accent);
  color: var(--app-on-accent);

  svg { width: 1.05rem; height: 1.05rem; }

  &:hover { background: var(--app-accent-hover); }
  &:focus-visible {
    outline: 3px solid var(--app-accent);
    outline-offset: 2px;
  }
}

.ew-topbar__user {
  /deep/ .nav-link {
    display: flex;
    align-items: center;
    height: 2.5rem;
    padding: 0 0.75rem;
    border-radius: var(--app-radius-sm);

    &:hover { background: var(--app-surface-muted); }
    &:focus-visible {
      outline: 3px solid var(--app-accent);
      outline-offset: 2px;
    }
  }

  /deep/ .dropdown-menu {
    border: 1px solid var(--app-border);
    border-radius: var(--app-radius-md);
    box-shadow: 0 12px 28px rgba(7, 50, 88, 0.12);
    padding: 0.35rem;
  }

  /deep/ .dropdown-item {
    border-radius: var(--app-radius-sm);
    font-family: var(--app-font);
    font-size: 0.85rem;
    font-weight: 500;
    color: var(--app-navy-secondary);
    padding: 0.6rem 0.75rem;

    &:hover,
    &:focus {
      background: var(--app-surface-muted);
      color: var(--app-navy);
    }
  }
}

.ew-topbar__user-name {
  font-family: var(--app-font);
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--app-navy);
}
</style>

<!-- El modal de bootstrap-vue se monta fuera del árbol scoped de este
     componente; se estiliza aparte con la clase que le pasamos vía
     modal-class, en una hoja global normal (no scoped). -->
<style lang="scss">
@import "../../assets/styles/app-tokens";

.ew-tracking-modal {
  .modal-content {
    border-radius: 0.85rem;
    border: none;
    overflow: hidden;
  }
  .modal-header {
    background: $app-navy;
    border-bottom: none;
    padding: 1.1rem 1.5rem;
  }
  .modal-title {
    font-family: $app-font-family;
    font-weight: 700;
    color: #fff;
  }
  .close {
    color: #fff;
    text-shadow: none;
    opacity: 0.85;
    &:hover { opacity: 1; }
  }
  .modal-body {
    font-family: $app-font-family;
  }
  .modal-footer {
    border-top: 1px solid $app-border;
    .btn-secondary {
      background: $app-navy;
      border-color: $app-navy;
      border-radius: 999px;
    }
  }
  thead th {
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: $app-muted;
  }
}

.ew-tracking-loading {
  font-family: $app-font-family;
  color: $app-muted;
  padding: 1rem 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Header/Navbar.vue